/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (!window.__bbjSidePanelSlotListener) {
  window.__bbjSidePanelSlotListener = true;
  document.addEventListener(
    'click',
    function (e) {
      const opener = e.target.closest('[data-open-side-panel-slot]');
      if (!opener) {
        return;
      }
      const slot = opener.getAttribute('data-open-side-panel-slot');
      if (!slot) {
        return;
      }
      const wrap = document.querySelector('side-panel-links.side-panel-links');
      if (!wrap) {
        return;
      }
      const target = wrap.querySelector('button.side-panel-links--link[data-id="' + slot + '"]');
      if (target) {
        e.preventDefault();
        e.stopPropagation();
        target.click();
      }
    },
    true
  );
}